<div class="flex h-full flex-col">
  <!-- Table Properties Controls - Fixed Height -->
  <div
    class="table-properties-section flex h-64 flex-shrink-0 flex-col gap-3 overflow-y-auto border-b border-neutral-200 p-4"
  >
    <!-- Title Input -->
    <dojo-multi-line-text
      [formCtrl]="titleFormCtrl"
      [size]="'s'"
      [label]="'Title'"
      [placeholder]="'Enter table title (optional)'"
      class="w-full"
    />

    @if (!editingOptions().hideImageAndTableMetadata) {
      <!-- Fill in the Blanks Toggle (if provided) -->
      @if (formCtrl().controls.fill_in_the_blanks) {
        <div class="flex items-center gap-2">
          <mat-slide-toggle [formControl]="formCtrl().controls.fill_in_the_blanks!" class="small" color="primary">
            <span class="text-sm font-semibold">Fill in the blanks</span>
          </mat-slide-toggle>
        </div>
      }

      <!-- Container Layout Select -->
      <dojo-single-select
        [size]="'s'"
        [label]="'Container Width'"
        [formCtrl]="containerLayoutFormCtrl"
        [optionValue]="'value'"
        [optionLabel]="'label'"
        [options]="containerLayoutOptions"
      ></dojo-single-select>

      <!-- Padding Controls -->
      <div class="flex flex-col gap-2">
        <label class="text-sm font-semibold text-neutral-700">Padding (px)</label>
        <div class="grid grid-cols-2 gap-2">
          <dojo-number-input
            [size]="'s'"
            [label]="'Top'"
            [formCtrl]="paddingTopFormCtrl"
            [min]="0"
            [max]="100"
            class="w-full"
          />
          <dojo-number-input
            [size]="'s'"
            [label]="'Right'"
            [formCtrl]="paddingRightFormCtrl"
            [min]="0"
            [max]="100"
            class="w-full"
          />
          <dojo-number-input
            [size]="'s'"
            [label]="'Bottom'"
            [formCtrl]="paddingBottomFormCtrl"
            [min]="0"
            [max]="100"
            class="w-full"
          />
          <dojo-number-input
            [size]="'s'"
            [label]="'Left'"
            [formCtrl]="paddingLeftFormCtrl"
            [min]="0"
            [max]="100"
            class="w-full"
          />
        </div>
      </div>
    }
  </div>

  <!-- Content Section - Calculated Height -->
  <div class="min-h-0 flex-1 p-4">
    <div class="flex h-full flex-col gap-3">
      <dojo-multi-line-text
        [formCtrl]="contentFormCtrl"
        [size]="'m'"
        [label]="'HTML Table'"
        [placeholder]="'Enter your table in HTML format...'"
        class="flex-1"
      />
    </div>
  </div>
</div>
